export const radio = [
  {
    id: "r009",
    title: "NTS Radio: DUST2DUST w/ Juan Falibene",
    place: "Barcelona",
    date: "12.04.26",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2301547544&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://www.nts.live/shows/your-specialist-subject-ii/episodes/your-specialist-subject-ii-dust2dust-w-juan-falibene-12th-april-2026",
    cover:
      "https://i1.sndcdn.com/artworks-aRoxr92VCgOb4Un8-cypOng-t1080x1080.jpg",
    genres: ["Soul", "Funk", "Rare Groove"],
    category: "radio",
  },
  {
    id: "r008",
    title: "Dublab.cat: B-sides 08.04.26 w/ Juan Falibene",
    place: "Barcelona",
    date: "08.04.26",
    embed:
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&autoplay=1&feed=%2Fdublabes%2Fb-sides-080426-w-juan-falibene%2F",
    url: "https://dublab.cat/b-sides/juan-falibene",
    cover: "./img/r008.jpg",
    genres: ["Jazz", "Soul-Jazz", "Free-Jazz", "Live Recording"],
    category: "radio",
  },
  {
    id: "r007",
    title: "NTS Radio: Heatwave Mixtape",
    place: "Barcelona",
    date: "09.08.24",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1895404959&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://www.nts.live/shows/heatwave/episodes/heatwave-heatwave-strikes-again-and-it-will-never-be-the-same-again-9th-august-2024",
    cover: "./img/r007.jpg",
    genres: ["Jazz", "Soul", "Disco"],
    category: "radio",
  },
  {
    id: "r001",
    title: "NTS Radio: Sounds, Healing, mixtape",
    place: "Barcelona",
    date: "07.04.23",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1485705940&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://www.nts.live/shows/heartbreak-2023/episodes/heartbreak-2023-sounds-healing-mixtape-7th-april-2023",
    cover: "./img/r001.jpeg",
    genres: ["Soul", "Funk", "Disco"],
    category: "radio",
  },
  {
    id: "r005",
    title: "NOODS Radio: Espressoul",
    place: "London",
    date: "29.11.22",
    embed:
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&autoplay=1&feed=%2FNoodsRadio%2Fespressoul-29th-november-22%2F",
    url: "https://noodsradio.com/shows/espressoul-29th-november-22",
    cover: "./img/r005.jpeg",
    genres: ["Soul", "Funk", "Jazz-Rock"],
    category: "radio",
  },
  {
    id: "r003",
    title: "Radio Buena Vida: Sounds, Healing, Mixtape w/ Juan Falibene",
    place: "Glasgow",
    date: "27.01.23",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1435133236&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://soundcloud.com/radiobuenavida/sounds-healing-mixtape-w-juan-falibene-radio-buena-vida-270123/sets",
    cover: "./img/r004.jpeg",
    genres: ["Soul", "Funk", "Jazz"],
    category: "radio",
  },
  {
    id: "r006",
    title: "NTS Radio: I´ll Call it Verano",
    place: "Barcelona",
    date: "18.08.22",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1326992341&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://www.nts.live/shows/summer-of-love-2022/episodes/i-ll-call-it-verano-18th-august-2022",
    cover: "./img/r006.jpeg",
    genres: ["Soul", "Funk", "Classic Disco", "70´s"],
    category: "radio",
  },
  {
    id: "r005",
    title: "NOODS Radio: I´ll Call It Morning Soul",
    place: "London",
    date: "12.10.22",
    embed:
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&autoplay=1&feed=%2FNoodsRadio%2Fill-call-it-morning-soul%2F",
    url: "https://noodsradio.com/shows/i-ll-call-it-morning-soul-12th-october-22",
    cover: "./img/r003.jpeg",
    genres: ["Soul", "Funk", "Jazz"],
    category: "radio",
  },
  {
    id: "r003",
    title: "Radio Buena Vida: Espressoul w/ Juan Falibene",
    place: "Glasgow",
    date: "19.03.23",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1473439849&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://soundcloud.com/radiobuenavida/espressoul-w-juan-falibene-radio-buena-vida-190323",
    cover: "./img/r002.jpeg",
    genres: ["Soul", "Funk", "Free-Jazz"],
    category: "radio",
  },
];

export const mixes = [
  {
    id: "m0010",
    title: "Disco Between Cafe",
    place: "Madrid",
    date: "04.08.19",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/668604836&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://soundcloud.com/juanfalibene/disco-between-cafe",
    cover: "./img/m001.jpeg",
    genres: ["Disco-House", "Disco-Funk", "Disco"],
    category: "mixes",
  },
  {
    id: "m009",
    title: "Juan Falibene @ Clot Warehouse by C/C Radio",
    place: "Barcelona",
    date: "23.12.20",
    embed: "https://www.youtube.com/embed/MtrPOt_9jz4?si=Eb-Tq7iDMT1d_DHS",
    url: "https://www.youtube.com/watch?v=MtrPOt_9jz4&t=2s&ab_channel=PoblenouCommunityRadio",
    cover: "./img/m004.jpeg",
    genres: ["House", "Funk", "Disco", "Live Recording"],
    category: "mixes",
  },
  {
    id: "m008",
    title: "Sounds, Healing, Mixtape",
    place: "Madrid",
    date: "13.02.20",
    embed:
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&autoplay=1&feed=%2Fjuanfalibene%2Fsounds-healing-mixtape%2F",
    url: "https://www.mixcloud.com/juanfalibene/sounds-healing-mixtape/",
    cover:
      "https://thumbnailer.mixcloud.com/unsafe/580x580/extaudio/8/3/0/1/da2c-39db-4056-a493-ff95f6087683",
    genres: ["Soul", "Funk", "Jazz-Funk"],
    category: "mixes",
  },
  {
    id: "m007",
    title: "Sounds, Healing, Mixtape II",
    place: "Madrid",
    date: "22.02.20",
    embed:
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&autoplay=1&feed=%2Fjuanfalibene%2Fsounds-healing-mixtape-2%2F",
    url: "https://www.mixcloud.com/juanfalibene/sounds-healing-mixtape-2/",
    cover:
      "https://thumbnailer.mixcloud.com/unsafe/580x580/extaudio/0/3/7/c/8eac-03e5-4558-b74c-20641ec72535",
    genres: ["Soul", "Funk", "Jazz-Funk"],
    category: "mixes",
  },
  {
    id: "m006",
    title: "Haüz III",
    place: "Madrid",
    date: "01.08.19",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A389038629&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://soundcloud.com/imhauz/hauz3",
    cover: "https://i1.sndcdn.com/artworks-000445632243-v52o8h-t1080x1080.jpg",
    genres: ["Deep House", "House", "Electronic"],
    category: "mixes",
  },
  {
    id: "m005",
    title: "Haüz II",
    place: "Madrid",
    date: "02.04.19",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A338785596&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://soundcloud.com/imhauz/hauz2",
    cover: "https://i1.sndcdn.com/artworks-000445632354-ifhr5s-t1080x1080.jpg",
    genres: ["Deep House", "House", "Nu Disco"],
    category: "mixes",
  },
  {
    id: "m004",
    title: "Haüz I",
    place: "Madrid",
    date: "16.11.18",
    embed:
      "https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A331548990&color=%23384336&auto_play=true&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false",
    url: "https://soundcloud.com/imhauz/hauz1",
    cover: "https://i1.sndcdn.com/artworks-000445633590-8imvc7-t1080x1080.jpg",
    genres: ["Deep House", "House"],
    category: "mixes",
  },
  {
    id: "m003",
    title: "TCCBR from Café Pavón",
    place: "Madrid",
    date: "02.11.18",
    embed: "https://www.youtube.com/embed/K5GpaYMqfs0?si=LAp-ieqIgs9u12Kp",
    url: "https://www.mixcloud.com/juanfalibene/sounds-healing-mixtape/",
    cover: "./img/m005.jpeg",
    genres: ["Soul", "Funk", "Jazz-Funk", "Live Recording"],
    category: "mixes",
  },
  {
    id: "m002",
    title: "La Radio live #090 Juan Falibene",
    place: "Barcelona",
    date: "04.10.17",
    embed: "https://www.youtube.com/embed/5BiBmhEs_iM?si=y1DZaxLEMyYqd8pt",
    url: "https://www.youtube.com/watch?v=5BiBmhEs_iM&ab_channel=LaRadio",
    cover: "./img/m003.jpeg",
    genres: ["Soul", "Funk", "Disco", "Live Recording"],
    category: "mixes",
  },
  {
    id: "m001",
    title: "Tuesnight Selection @ Café Berlín",
    place: "Madrid",
    date: "10.11.16",
    embed:
      "https://player-widget.mixcloud.com/widget/iframe/?hide_cover=1&light=1&autoplay=1&feed=%2Fjuanfalibene%2Ftuesnight-selection-caf%C3%A9-berl%C3%ADn-10-11%2F",
    url: "https://www.mixcloud.com/juanfalibene/tuesnight-selection-caf%C3%A9-berl%C3%ADn-10-11/",
    cover: "./img/m002.jpeg",
    genres: ["Nudisco", "Indie-Dance", "House", "Live Recording"],
    category: "mixes",
  },
];

export const playlists = [
  {
    id: "p001",
    title: "Josealfredo #018",
    place: "Madrid",
    date: "01.02.18",
    embed:
      "https://open.spotify.com/embed/playlist/5k3M5kwIwpTKJGSC1rXEIK?utm_source=generator",
    url: "https://open.spotify.com/playlist/5k3M5kwIwpTKJGSC1rXEIK?si=f22d57ebc7a845ee",
    cover: "./img/p001.jpg",
    genres: ["Jazz", "Soul", "Modern-Soul"],
    category: "playlists",
  },
  {
    id: "p003",
    title: "Club Vermut Radio🍸📻 #01",
    place: "San Antonio de Areco",
    date: "27.06.22",
    embed:
      "https://open.spotify.com/embed/playlist/5CcaOxzmaWy0Opr8fMZW2p?utm_source=generator",
    url: "https://open.spotify.com/playlist/5CcaOxzmaWy0Opr8fMZW2p?si=9966d5c680834bb1",
    cover: "./img/p003.jpg",
    genres: ["Neo-Soul", "Soul", "Hip-Hop"],
    category: "playlists",
  },
  {
    id: "p002",
    title: "MAZU Cantina🌴",
    place: "Las Palmas Gran Canarias",
    date: "16.09.21",
    embed:
      "https://open.spotify.com/embed/playlist/2XcPkDqLPhe82RNRQHvBD4?utm_source=generator",
    url: "https://open.spotify.com/playlist/2XcPkDqLPhe82RNRQHvBD4?si=a60841dad0184620",
    cover: "./img/p002.jpg",
    genres: ["Jazz", "Brasil", "Bossa"],
    category: "playlists",
  },
  {
    id: "p004",
    title: "Pajaritos Mojados",
    place: "Madrid",
    date: "08.03.19",
    embed:
      "https://open.spotify.com/embed/playlist/4qlHSNPDqeBIHlrR5AIk2J?utm_source=generator",
    url: "https://open.spotify.com/playlist/4qlHSNPDqeBIHlrR5AIk2J?si=e8e32c6c2a0b4a40",
    cover: "./img/p004.jpg",
    genres: ["Disco", "Dance", "Boogie"],
    category: "playlists",
  },
];

export const recommendations = {
  Albums: [
    {
      id: "A-001",
      name: "WHAT'S GOING ON - MARVIN GAYE",
      image:
        "https://i.discogs.com/ywu8mUs3NJhauOHQZBerCMDaFR3q5s2YDHmFzoKeLPA/rs:fit/g:sm/q:90/h:592/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTI2MTk3/ODI2LTE2NzcxNTQ1/MTctMjE2Ny5qcGVn.jpeg",
      link: "https://www.discogs.com/master/66631-Marvin-Gaye-Whats-Going-On",
    },
    {
      id: "A-002",
      name: "BLACK MESSIAH - D'ANGELO",
      image:
        "https://i.discogs.com/DSY_HhBmPdcMoLUjYjxN0628AyzPHXWEfqgQWsJOeLs/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTY0MjAy/MTYtMTUyODQyNDM1/MS0zMzc3LmpwZWc.jpeg",
      link: "https://www.discogs.com/master/771416-DAngelo-And-The-Vanguard-Black-Messiah",
    },
    {
      id: "A-003",
      name: "PIECES OF A MAN - GIL SCOTT-HERON",
      image:
        "https://i.discogs.com/m8ECSgKq6jMcKzXJ54dsP8gpjirahlmKvibuYlHHphA/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTQzMDY5/MC0xNTgxODA0ODE1/LTc5NDcuanBlZw.jpeg",
      link: "https://www.discogs.com/master/7608-Gil-Scott-Heron-Pieces-Of-A-Man",
    },
    {
      id: "A-004",
      name: "DOO-BOP - MILES DAVIS",
      image:
        "https://i.discogs.com/Q4FtGHeKVubOMZNLaJiw9YhUHaYoVuWWsG4YKnkFurA/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTEzMTk4/MTAtMTIwOTM2Mzg0/My5qcGVn.jpeg",
      link: "https://www.discogs.com/master/62359-Miles-Davis-Doo-Bop",
    },
    {
      id: "A-005",
      name: "OFF THE WALL - MICHAEL JACKSON",
      image:
        "https://i.discogs.com/zl5v5VCYQuYQcQtCa2xNah3p9LlsCDvObhfYWdGLjP4/rs:fit/g:sm/q:90/h:344/w:358/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTEyMDA5/Ni0xMDg1NjAwNjA3/LmpwZw.jpeg",
      link: "https://www.discogs.com/master/435524-Michael-Jackson-Off-The-Wall",
    },
  ],
  Artists: [
    {
      id: "AR-001",
      name: "MARVIN GAYE",
      image:
        "https://i.discogs.com/IdfmtTrrkGB2g9qoIqZDBAguS1eexwuPc_vKfHyXXaI/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE4OTg0/LTE2NDkyNDk5NDYt/Njg1MC5qcGVn.jpeg",
      link: "https://es.wikipedia.org/wiki/Marvin_Gaye",
    },
    {
      id: "AR-002",
      name: "LEROY HUTSON",
      image:
        "https://i.discogs.com/JkJMtaQ7uVdCrKY9-kNdGGN3Le5TEORgU8zMdGWXPPg/rs:fit/g:sm/q:90/h:404/w:524/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTU2Njgt/MTUwMTQyNTE3Mi01/MDkyLmpwZWc.jpeg",
      link: "https://en.wikipedia.org/wiki/Leroy_Hutson",
    },
    {
      id: "AR-003",
      name: "GIL SCOTT-HERON",
      image:
        "https://i.discogs.com/7TW26mYrsEdM46xg2uTZe_eEGcAcrphoDSst6qZgCL4/rs:fit/g:sm/q:90/h:600/w:545/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE2NTMz/LTEyNjY1MTc5ODEu/anBlZw.jpeg",
      link: "https://es.wikipedia.org/wiki/Gil_Scott-Heron",
    },
    {
      id: "AR-004",
      name: "ROY AYERS",
      image:
        "https://i.discogs.com/SZ9FD3Op3R6_0FmmpMyJuDZHIuiTA9UsVxpPG2A9GXE/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTIyNjUt/MTU5MTA1MDU1MS03/NDYxLmpwZWc.jpeg",
      link: "https://es.wikipedia.org/wiki/Roy_Ayers",
    },
    {
      id: "AR-005",
      name: "MICHAEL JACKSON",
      image:
        "https://i.discogs.com/5BkauSTPcfB13R5z7Hj517JpL3qgEH-DwZmaYVR-LuQ/rs:fit/g:sm/q:90/h:300/w:302/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE1ODg1/LTE1MzkxMDU4NDUt/Njk3Ny5qcGVn.jpeg",
      link: "https://es.wikipedia.org/wiki/Michael_Jackson",
    },
  ],
  Singles: [
    {
      id: "S-001",
      name: "ALL BECAUSE OF YOU - LEROY HUTSON",
      image:
        "https://i.discogs.com/lWciTjZxLYbIxQuSdnhHhRbG-Bkj4QaBonJaW0hR6xc/rs:fit/g:sm/q:90/h:600/w:596/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTI0MzUy/NTY4LTE2NjE4MjE3/NTEtMTUzNy5qcGVn.jpeg",
      link: "https://www.discogs.com/master/353971-Leroy-Hutson-All-Because-Of-You",
    },
    {
      id: "S-002",
      name: "OUR LIVES ARE SHAPED BY WHAT WE LOVE - ODYSSEY",
      image:
        "https://i.discogs.com/2tJntr9bOm362Rw5W1OgnKUVboQ-ItucU9zxOSt9P0M/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTg1Nzk2/MDEtMTUxMDgzNjA1/MC0yMjEzLmpwZWc.jpeg",
      link: "https://www.discogs.com/master/1109983-Odyssey-Our-Lives-Are-Shaped-By-What-We-Love",
    },
    {
      id: "S-003",
      name: "COME WHAT MAY - JOHN GARY WILLIAMS",
      image:
        "https://i.discogs.com/Z7PVYpgDTqPpG1sFRUhuUXoDYw9-ZzLZVJj-yDX3X7w/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTU5MjA3/MDQtMTQwNjM3NDIw/Ny01MjIyLmpwZWc.jpeg",
      link: "https://www.discogs.com/master/748483-John-Gary-Williams-Come-What-May-Just-Aint-No-Love-Without-You-Here",
    },
    {
      id: "S-004",
      name: "I LOVE YOU MORE AND MORE - TOM BROCK",
      image:
        "https://i.discogs.com/51GqJ8GRh7eY1W6ZM4iX5T_s3CZnxsfbQYahRjptNCU/rs:fit/g:sm/q:90/h:596/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTEwMDM2/OTUtMTE4Mjk0OTkw/Ni5qcGVn.jpeg",
      link: "https://www.discogs.com/release/1003695-Tom-Brock-If-We-Dont-Make-It-Nobody-Can-",
    },
    {
      id: "S-005",
      name: "ARE YOU LONELY? - HIPNOTIC",
      image:
        "https://i.discogs.com/GJMsw9ji-HVyyU-4WymoATUYAS_m89XV3s_Zaumc5Is/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTIzNDU2/Ny0xMzg5NjQ3MTE1/LTQ1NzYuanBlZw.jpeg",
      link: "https://www.discogs.com/master/239629-Hipnotic-Are-You-Lonely",
    },
    {
      id: "S-006",
      name: "WHAT IT COME DOWN TO - ISLEY BROTHERS",
      image:
        "https://i.discogs.com/FvZXhI6kXVpQosSR6bAdM0saWNk3HZwImneHaD-i0Co/rs:fit/g:sm/q:90/h:600/w:597/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTEwMTAz/NzItMTI4MDU2MzI2/Mi5qcGVn.jpeg",
      link: "https://www.discogs.com/master/320626-Isley-Brothers-What-It-Comes-Down-To",
    },
  ],
  Producers: [
    {
      id: "PR-001",
      name: "QUINCY JONES",
      image:
        "https://i.discogs.com/HqfuZ7UgWE90Jq4EKbZbTHlE3v9gsIOlWXX7s0KDJEA/rs:fit/g:sm/q:90/h:569/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE3NTQ2/LTE1MDQyNzYyMzQt/MjU0MS5qcGVn.jpeg",
      link: "https://es.wikipedia.org/wiki/Quincy_Jones",
    },
    {
      id: "PR-002",
      name: "J DILLA",
      image:
        "https://i.discogs.com/HYD_BuSJP76RcZb62FK6JKyhLw6LheqzG8c10akjAHA/rs:fit/g:sm/q:90/h:600/w:480/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTMyNDg2/Ni0xNjk3ODc3NzY4/LTcyMzQuanBlZw.jpeg",
      link: "https://es.wikipedia.org/wiki/J_Dilla",
    },
    {
      id: "PR-003",
      name: "ROY AYERS",
      image:
        "https://i.discogs.com/SZ9FD3Op3R6_0FmmpMyJuDZHIuiTA9UsVxpPG2A9GXE/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTIyNjUt/MTU5MTA1MDU1MS03/NDYxLmpwZWc.jpeg",
      link: "https://es.wikipedia.org/wiki/Roy_Ayers",
    },
    {
      id: "PR-004",
      name: "RYUICHI SAKAMOTO",
      image:
        "https://i.discogs.com/7YTkTuNyLmZ2VVogHVsN2sGxDWuuY8bO1XOBQ5dt8qQ/rs:fit/g:sm/q:90/h:600/w:464/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTUwODct/MTUyODEzNTM3NC01/ODEzLmpwZWc.jpeg",
      link: "https://es.wikipedia.org/wiki/Ryuichi_Sakamoto",
    },
    {
      id: "PR-005",
      name: "JOHN MORALES",
      image:
        "https://i.discogs.com/VYRUVxoD2pZNVJDSCj8UxtrS7363vFx71TGvhxwlMtQ/rs:fit/g:sm/q:90/h:339/w:284/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTQ5MjU4/LTExNDI2MDk5NzEu/anBlZw.jpeg",
      link: "https://en.wikipedia.org/wiki/Morales_and_Munzibai",
    },
  ],
  Labels: [
    {
      id: "L-001",
      name: "MOTOWN",
      image:
        "https://i.discogs.com/jM1vQlRNLteMWR1T9z6Nlc5gvbNTn5H2fDJYNl6wSDI/rs:fit/g:sm/q:90/h:538/w:538/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9MLTE3MjMt/MTM0Mzc4MTQ3OS0y/NzIxLmdpZg.jpeg",
      link: "https://en.wikipedia.org/wiki/Motown",
    },
    {
      id: "L-002",
      name: "STAX",
      image:
        "https://i.discogs.com/1E3afTn3nuDXtWBrVaCcBAAC4KivwPy-rokGtVsb9BQ/rs:fit/g:sm/q:90/h:584/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9MLTI0OTM2/LTE0MzY0ODI3NzMt/NTYwMS5qcGVn.jpeg",
      link: "https://en.wikipedia.org/wiki/Stax_Records",
    },
    {
      id: "L-003",
      name: "ATLANTIC",
      image:
        "https://i.discogs.com/HltkdWo2w3_AapPPADEguuKGq7M8iL8HftZGWOgA2yo/rs:fit/g:sm/q:90/h:570/w:570/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9MLTY4MS0x/NDQ3MjQ2Mjg0LTgy/NzkuanBlZw.jpeg",
      link: "https://en.wikipedia.org/wiki/Atlantic_Records",
    },
    {
      id: "L-004",
      name: "PHILADELPHIA INTERNATIONAL RECORDS",
      image:
        "https://i.discogs.com/iSaw4Lx9wf-BslLA5a12un30ksvZApJpQnz3G1LeozA/rs:fit/g:sm/q:90/h:304/w:304/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9MLTExOTEw/LTEzOTUxNDU0MzEt/OTU0MC5qcGVn.jpeg",
      link: "https://en.wikipedia.org/wiki/Philadelphia_International_Records",
    },
    {
      id: "L-005",
      name: "ATHENS OF THE NORTH",
      image:
        "https://i.discogs.com/StkVRInMMD1sjv_pbdT9pnMY7i0nl4Uq2rdkwpi9Ms8/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9MLTY3OTM3/NS0xNTE3NTAzNDkx/LTczMjQucG5n.jpeg",
      link: "https://aotns.bandcamp.com/",
    },
  ],
  DJs: [
    {
      id: "DJ-001",
      name: "LARRY LEVAN",
      image:
        "https://i.discogs.com/RJcSFsI4NA6xioOdPqewTMEkvkQpJF-5wUQ1LnS7_Sk/rs:fit/g:sm/q:90/h:395/w:395/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTM0ODMt/MTE4Mjk2NTI5My5q/cGVn.jpeg",
      link: "https://es.wikipedia.org/wiki/Larry_Levan",
    },
    {
      id: "DJ-002",
      name: "DANILO PLESSOW",
      image:
        "https://i.discogs.com/nCr4PirXPPXXmFLpQjywZekWW_NPUNoTyxjZY_D7W6I/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTUyMTU4/NC0xNjgzODMzNDcy/LTY4NTAuanBlZw.jpeg",
      link: "https://daniloplessow.bandcamp.com/",
    },
    {
      id: "DJ-003",
      name: "SADAR BAHAR",
      image:
        "https://i.discogs.com/MLyVuB0bN87CPLlOPy0Li2xGeEKplH6f08xj6_nXBmo/rs:fit/g:sm/q:90/h:600/w:600/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTk0NzQ2/MS0xNjc1MzY2MzU0/LTEwNDguanBlZw.jpeg",
      link: "https://www.soundsfamiliar.it/roster/sadar-bahar",
    },
    {
      id: "DJ-004",
      name: "DJ SPINNA",
      image:
        "https://i.discogs.com/HV-WNA1r1S6HnAnGwOZVoc4jJJJTpz0btkyHCf5McAE/rs:fit/g:sm/q:90/h:600/w:532/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTE5MDUt/MTY0NDMxODkwMy02/OTEwLmpwZWc.jpeg",
      link: "https://www.djspinna.com/",
    },
    {
      id: "DJ-005",
      name: "GILES PETERSON",
      image:
        "https://i.discogs.com/d4VMd7BEaKpfKHwnhyxrur72h7XcOfl_ojdPj_zGcIU/rs:fit/g:sm/q:90/h:400/w:400/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9BLTgyNzgt/MTY5NTkxMTg2MS03/MDc2LmpwZWc.jpeg",
      link: "https://en.wikipedia.org/wiki/Gilles_Peterson",
    },
  ],
  Mixes: [
    {
      id: "M-001",
      name: "SOUL WITH A HOLE - MAYER HAWTHORNE",
      image:
        "https://i1.sndcdn.com/artworks-000049114033-f1xtsy-t1080x1080.jpg",
      link: "https://soundcloud.com/mayerhawthorne/soul-with-a-hole-vol-1?in=kidpbk/sets/play",
    },
    {
      id: "M-002",
      name: "LOVERS MELT III - FLYING LOTUS",
      image:
        "https://i1.sndcdn.com/artworks-000027400772-zlpg9i-t1080x1080.jpg",
      link: "https://soundcloud.com/selftitledmag/flying-lotus-lovers-melt-pt",
    },
    {
      id: "M-003",
      name: "BEDTIME STORIES - BREAKBOT & IRFANE",
      image:
        "https://i1.sndcdn.com/artworks-000052534531-4p2uyd-t1080x1080.jpg",
      link: "https://soundcloud.com/breakbot/breakbot-irfane-bedtime?in=10son/sets/mix",
    },
    {
      id: "M-004",
      name: "MIXMAG - THEO PARRISH",
      image: "https://i.ytimg.com/vi/W7a1wMFgyCA/maxresdefault.jpg",
      link: "https://youtu.be/W7a1wMFgyCA?si=e0iJcKwpbm_yvQkF",
    },
    {
      id: "M-005",
      name: "BOILER ROOM - ADRIAN YOUNGE",
      image: "https://i.ytimg.com/vi/TR57AC0VyZ4/maxresdefault.jpg",
      link: "https://youtu.be/TR57AC0VyZ4?si=Hds868J9YD6GHU0C",
    },
  ],
  Gigs: [
    {
      id: "G-001",
      name: "W/ HUGO LX @ CAFÉ BERLIN",
      image: "img/gigs/gigs005.jpg",
    },
    {
      id: "G-002",
      name: "W/ FOLAMOUR @ CAFÉ BERLIN",
      image: "img/gigs/gigs004.jpg",
    },
    {
      id: "G-003",
      name: "ALL NIGHT LONG @ CAFÉ BERLIN",
      image: "img/gigs/gigs003.jpg",
    },
    {
      id: "G-004",
      name: "PAMPA W/ MANU DESRETS @ CAFÉ BERLIN",
      image: "img/gigs/gigs001.jpg",
    },
    {
      id: "G-005",
      name: "PAMPA W/ PABELS & PANDO @ CAFÉ BERLIN",
      image: "img/past_gigs/2026-05-29_berlin-club-pabels.jpg",
    },
    {
      id: "G-006",
      name: "BEATS & RHYMES & LIFE @ CURTIS",
      image: "img/gigs/gigs002.jpg",
    },
  ],
};
export const next = {
  Venues: [
    {
      date: "14-08-2026",
      venue: "BLACKIE & FRIENDS @ SALVADISCOS",
      link: "https://www.instagram.com/salvadiscos/",
    },
    {
      date: "16-08-2026",
      venue: "Vinyl Selection @ Culkin",
      link: "https://www.instagram.com/culkinbcn",
    },
    {
      date: "22-08-2026",
      venue: "Vinyl Selection @ Imperdible",
      link: "https://www.instagram.com/imperdible.bcn/",
    },
    {
      date: "10-09-2026",
      venue: "B-UNITED @ SALVADISCOS",
      link: "https://www.instagram.com/salvadiscos/",
    },
    {
      date: "20-09-2026",
      venue: "Vinyl Selection @ CURTIS",
      link: "https://www.instagram.com/curtisaudiocafe/",
    },
  ],
};
